import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import Panel from '../shared/Panel';
import SearchFacets from '../SearchFacets';
import AccountTable from '../AccountTable';
import * as actions from '../../redux/actions';
import {
	getSearchParams,
	getSearchedAccounts,
	getSearchedAccountsCount,
	getSearchedAccountsFilters
} from '../../redux/reducers';
import { removeEmpty, concat } from '../../utils';

class AccountSearch extends Component {
	state = {
		viewParams: {
			offset: 0,
			limit: 25,
			page: 1,
			sort: 'createdOn',
			order: 'desc'
		},
		filterParams: {}
	};

	componentDidMount = () => {
		const { searchParams } = this.props;
		// console.log('AccountSearch searchParams = ', searchParams);
		this.fetchData();
	};

	componentDidUpdate(prevProps) {
		if (this.props.searchParams !== prevProps.searchParams) {
			this.fetchData();
		}
	}

	fetchData = () => {
		const { searchParams, fetchAccounts } = this.props;
		const { viewParams, filterParams } = this.state;

		const params = { ...searchParams, ...viewParams };
		// console.log('params = ', params);
		const queryParams = removeEmpty(params);
		// console.log('queryParams = ', queryParams);
		const esc = encodeURIComponent;
		const searchQuery = Object.keys(queryParams).map((p) => esc(p) + '=' + esc(queryParams[p])).join('&');
		// console.log('searchQuery = ', searchQuery);
		const filterQuery = Object.keys(filterParams)
			.map((f) => {
				const values = filterParams[f];
				return values.map((v) => esc(f) + '=' + esc(v)).join('&');
			})
			.join('&');
		// console.log('filterQuery = ', filterQuery);
		const query = searchQuery + '&' + filterQuery;
		// console.log('query = ', query);

		fetchAccounts(query, filterQuery ? true : false);
	};

	loadData = (viewParams) => {
		const params = { ...this.state.viewParams, ...viewParams };
		this.setState({ viewParams: params }, () => this.fetchData());
	};

	showAccountDetails = (account) => this.props.history.push(`/accounts/${account.accountID}`);

	handleFilterToggle = (e, { name, checked, category }) => {
		// console.log('handleFilterToggle');
		// console.log('name = ', name);
		// console.log('checked = ', checked);
		// console.log('category = ', category);
		const oldArray = this.state.filterParams[category] || [];
		// console.log('oldArray = ', oldArray);
		let newArray;
		if (checked) newArray = concat([ name ], oldArray);
		else {
			newArray = oldArray.filter((k) => k !== name);
		}

		// console.log('newArray = ', newArray);
		//...this.state.filterParams.category, name === this line was commented out before commenting out the logs
		this.setState(
			{
				filterParams: {
					...this.state.filterParams,
					[category]: newArray
				},
				viewParams: {
					...this.state.viewParams,
					offset: 0
				}
			},
			() => this.fetchData()
		);
	};

	render() {
		const { filters, accounts, totalCount } = this.props;
		const { viewParams: { limit, offset, sort, order } } = this.state;
		// console.log('TXN Search filters = ', filters);
		return (
			<Grid padded stackable>
				{filters && (
					<Grid.Column width={4}>
						<SearchFacets isComingFrom="accounts" filters={filters} onFilterToggle={this.handleFilterToggle} />
					</Grid.Column>
				)}
				<Grid.Column width={filters ? 12 : 16}>
					<Panel>
						<AccountTable
							totalCount={totalCount}
							accounts={accounts}
							limit={limit}
							offset={offset}
							sort={sort}
							order={order}
							loadData={this.loadData}
							showDetails={this.showAccountDetails}
						/>
					</Panel>
				</Grid.Column>
			</Grid>
		);
	}
}

const mapStateToProps = (state) => ({
	searchParams: getSearchParams(state),
	accounts: getSearchedAccounts(state),
	totalCount: getSearchedAccountsCount(state),
	filters: getSearchedAccountsFilters(state)
});

AccountSearch = withRouter(connect(mapStateToProps, actions)(AccountSearch));

export default AccountSearch;
